<template>
</template>
    <script>
        var isMobile = {
        Android: function() {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
            return navigator.userAgent.match(/IEMobile/i);
        },
        any: function() {
            return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
        }

    };



if ( isMobile.Android() ) {
        document.location.href = "https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=ar.com.resimple.app";
		//document.location.href = "https://play.google.com/apps/testing/ar.com.resimple.app";
    }
else if(isMobile.iOS())
{
document.location.href = "https://apps.apple.com/us/app/resimple/id1454559002?l=es&ls=1";
}else{
    document.location.href = "https://www.resimple.com.ar";
}
    </script>